import React from 'react';
import styles from './linkEntity.module.scss';
import Avatar from 'v2/Avatar/Avatar';
import { LinkEntityInfoType } from 'v2/models';
import MarkdownRender from 'components/MarkdownRender/MarkdownRender';

interface EntityBoxProps {
  entity: LinkEntityInfoType;
  onRemove: () => void;
}

const EntityBox = ({ entity, onRemove }: EntityBoxProps) => {
  return (
    <div className={styles.existingEntityBox}>
      <Avatar url={entity.avatar} className={styles.existingEntityAvatar} />
      <div className={styles.existingEntityInfo}>
        <p className={styles.existingEntityName}>{entity.name}</p>
        <MarkdownRender
          className={styles.existingEntityDescription}
          source={entity.description || ''}
          format={false}
        />
      </div>
      <span className={styles.remove} onClick={() => onRemove()}>
        Remove
      </span>
    </div>
  );
};

export default EntityBox;
